<template>
  <el-dialog :title="$t('gridWorker.title')" :visible.sync="visible" width="25%" @close="closeDialog">
    <el-form ref="form" :model="formData" :rules="rules" label-width="180px">
     
    <el-form-item :label="$t('pet.form.name')" prop="name">
      <el-input v-model="formData.name" :placeholder="$t('pet.form.namePlaceholder')" />
    </el-form-item>

    <el-form-item :label="$t('pet.form.phone')" prop="phone">
      <el-input v-model="formData.phone" :placeholder="$t('pet.form.phonePlaceholder')" />
    </el-form-item>
    
    <el-form-item :label="$t('pet.form.kind')" prop="kind">
      <el-input v-model="formData.kind" :placeholder="$t('pet.form.kindPlaceholder')" />
    </el-form-item>

    <el-form-item :label="$t('pet.form.startTime')" prop="startTime">
      <el-date-picker style="width: 100%" v-model="formData.startTime" value-format="yyyy-MM" format="yyyy-MM" type="month" :placeholder="$t('pet.form.startTimePlaceholder')" />
    </el-form-item>
      <el-form-item :label="$t('pet.form.isfy')" prop="isfy">
        <el-radio-group v-model="formData.statusCd">
          <el-radio label="0">{{ $t('pet.form.inUse') }}</el-radio>
          <el-radio label="1">{{ $t('pet.form.invalid') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('pet.form.istx')" prop="istx">
        <el-radio-group v-model="formData.statusCd">
          <el-radio label="0">{{ $t('pet.form.inUse') }}</el-radio>
          <el-radio label="1">{{ $t('pet.form.invalid') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('pet.form.isqs')" prop="isqs">
        <el-radio-group v-model="formData.statusCd">
          <el-radio label="0">{{ $t('pet.form.inUse') }}</el-radio>
          <el-radio label="1">{{ $t('pet.form.invalid') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('pet.form.isgz')" prop="isgz">
        <el-radio-group v-model="formData.statusCd">
          <el-radio label="0">{{ $t('pet.form.inUse') }}</el-radio>
          <el-radio label="1">{{ $t('pet.form.invalid') }}</el-radio>
        </el-radio-group>
      </el-form-item>
       <el-form-item :label="$t('pet.form.isgs')" prop="isgs">
        <el-radio-group v-model="formData.statusCd">
          <el-radio label="0">{{ $t('pet.form.inUse') }}</el-radio>
          <el-radio label="1">{{ $t('pet.form.invalid') }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('gridWorker.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('gridWorker.submit') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveRepairSetting } from '@/api/work/repairSettingApi'

export default {
  name: 'AddGridWorker',
  data() {
    return {
      visible: false, 
      formData: {
        repairTypeName: '',
        repairWay: '200',
        repairSettingType: '200',
        remark: '',
        publicArea: 'F',
        payFeeFlag: 'F',
        returnVisitFlag: '003',
        isShow: 'Y',
        doTime: 24,
        warningTime: 30,
        notifyWay: 'WECHAT'
      },
      rules: {
        name: [
          { required: true, message: this.$t('gridWorker.namePlaceholder'), trigger: 'blur' },
        ],
        phone: [
          { required: true, message: this.$t('pet.form.phonePlaceholder'), trigger: 'blur' },
        ],
        kind: [
          { required: true, message: this.$t('pet.form.kindPlaceholder'), trigger: 'blur' },
        ],
        startTime: [
          { required: true, message: this.$t('pet.form.startTimePlaceholder'), trigger: 'blur' },
        ],
        isfy: [
          { required: true, message: this.$t('pet.form.isfyPlaceholder'), trigger: 'change' }
        ],
        istx: [
          { required: true, message: this.$t('pet.form.istxPlaceholder'), trigger: 'change' }
        ],  
        isqs: [
          { required: true, message: this.$t('pet.form.isqsPlaceholder'), trigger: 'change' }
        ],
        isgz: [
          { required: true, message: this.$t('pet.form.isgzPlaceholder'), trigger: 'change' }
        ],
        isgs: [
          { required: true, message: this.$t('pet.form.isgsPlaceholder'), trigger: 'change' }
        ],
       
      }
    }
  },
  methods: {
    open() {
      this.visible = true
    },

    closeDialog() {
      this.visible = false
      this.resetForm()
    },

    resetForm() {
      this.$refs.form.resetFields()
      this.formData = {
        repairTypeName: '',
        repairWay: '200',
        repairSettingType: '200',
        remark: '',
        publicArea: 'F',
        payFeeFlag: 'F',
        returnVisitFlag: '003',
        isShow: 'Y',
        doTime: 24,
        warningTime: 30,
        notifyWay: 'WECHAT'
      }
    },

    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await saveRepairSetting(this.formData)
            this.$message.success(this.$t('common.operationSuccess'))
            this.$emit('success')
            this.closeDialog()
          } catch (error) {
            console.error('添加报修设置失败:', error)
            this.$message.error(this.$t('repairSetting.addFailed'))
          }
        }
      })
    }
  }
}
</script>